__turbopack_context__.v({
  "body": "UtxoItem-module__zTsFtW__body",
  "btc": "UtxoItem-module__zTsFtW__btc",
  "icon": "UtxoItem-module__zTsFtW__icon",
  "root": "UtxoItem-module__zTsFtW__root",
  "usd": "UtxoItem-module__zTsFtW__usd",
});
